/* eslint-disable global-require */
module.exports = {
	common: require("./common.json"),
};
